import React from 'react';
import { Loader } from "./layout/Loader";
import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { WorksList } from './WorksList';

export const Start = () => {


  return <div className="page">

    {/*  Hero Section */}
    <section className="hero">
      <div className="hero-content">

        <div className="hero-background"></div>
        <span className="hero-intro">Innova • Optimiza • Soluciona</span>
        <img src="../images/smartphone.png" alt="smartphone" className="hero-smartphone"></img>
        <h1 className="hero-title">Impulsamos <br />tu Negocio <br /><span>Web</span></h1>
        <p className='desktopsize'>Desarrollo a medida de sitios Web<br/> con diseños atractivos y entornos UI/UX<br/> que generan resultados.</p>
        <p className='mobilesize'>Devs N Designs te ayuda a posicionarte en la web con Soluciones modernas para Diseñar y Desarrollar el Entorno Virtual de tu Negocio.</p>
        
        <img src="../images/laptop.png" alt="Logo" className="hero-laptop"></img>

        <div className="hero-buttons">
          <button className="primary-btn">
            <Link to="/portfolio">Ver Proyectos</Link>
          </button>

          <button className="secondary-btn">
            <Link to="/services">Nuestros Servicios</Link>
          </button>
        </div>
      </div>
    </section>

    {/* Technologies banner section */}
    <section className="technologies-banner">
      <h2>Tecnologías de Desarrollo</h2>
      <div className="technologies-logos">
        <article className="technology-logo"> <img src="../images/react-logo.png" alt="React" /></article>       
        <article className="technology-logo"><img src="../images/nodejs-logo.png" alt="Node.js" /></article>
        <article className="technology-logo"><img src="../images/javascript-logo.png" alt="JavaScript" /></article>
        <article className="technology-logo"><img src="../images/mongodb-logo.png" alt="MongoDB" /></article>
        <article className="technology-logo"><img src="../images/expressjs-logo.png" alt="ExpressJS" /></article>
      </div>
    </section>
  </div>

}
